import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import swal from "sweetalert";
import axios from "axios";
import Button from "@material-ui/core/Button";
import { updateStatus } from "../../utils/UpdateStatus";
import "../../modal.css";
import { api_path } from "../../shared";
function AddPendingReviewModal(props) {
  const [REMARK, SET_REMARK] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isReceiveButtonDisabled, setReceiveButtonDisabled] = useState(true);
  const [getOrderStatus, setOrderStatus] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [selectOrderStatus, setSelectOrderStatus] = useState([]);

  useEffect(() => {
    let order_status = props.STATUS;
    if (order_status == "2") {
      //new
      setReceiveButtonDisabled(true);
    } else {
      setReceiveButtonDisabled(false);
    }
  }, []);
  useEffect(() => {
    fetchOrderStatus();
    setSelectOrderStatus(1);
    setOrderStatus({
      CUSTOMER_MASTER_VALUE: 1,
      CUSTOMER_MASTER_EN: "RECEIVE",
    });
  }, []);
  const fetchOrderStatus = () => {
    axios
      .get(api_path + `/MS_CUSTOMER_MASTER.php?type=PENDING_REASON`)
      .then((response) => {
        setOrderStatusList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleOrderStatusChange = (obj) => {
    setSelectOrderStatus(obj.value);
    setOrderStatus({
      CUSTOMER_MASTER_VALUE: obj.value,
      CUSTOMER_MASTER_EN: obj.label,
    });
  };

  return (
    <>
      <Button
        disabled={props.disabled} 
        type="button"
        fullWidth
        variant="contained"
        color="primary"
        onClick={handleShow}
      >
        Pending
      </Button>

      <Modal
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Pending Review</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              handleClose();
              e.preventDefault();
              updateStatus({
                ID: props.ID,
                STATUS: 3,
                REMARK: REMARK,
                USER_ID: props.USER_ID,
              });
            }}
            id="editmodal"
            className=""
          >
            <input type="hidden" value={props.ID} />

            <label>
              REASON:
              <Select
                styles={{
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                }}
                placeholder="Select..."
                value={getOrderStatus}
                options={orderStatusList}
                onChange={handleOrderStatusChange}
                getOptionLabel={(x) => x.label}
                getOptionValue={(x) => x.value}
                required
              />
            </label>
            <label>Remark:</label>
            <textarea
              id="txtArea"
              rows="3"
              cols="50"
              value={REMARK}
              onChange={(e) => SET_REMARK(e.target.value)}
              inputProps={{ maxLength: 250 }}
            ></textarea>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
          <button className="btn btn-primary" form="editmodal">
            Receive
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddPendingReviewModal;
